import React from 'react';
import FormSection from 'components/sales/formSection/formSection';
import localization from 'assets/localization/localization';
import Regex from 'services/utils/regex/Regex';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import 'react-times/css/classic/default.css';

const AddCorporateClientForm = ({ setFormData, formData }) => {
  return (
    <FormSection title={localization.clientDetails}>
      <ConstantInput
        label={localization.companyName}
        regex={Regex.text.test(formData?.company_name)}
        errorMsg={localization.requiredCompanyName}
        type="text"
        required
        isStarRequired={true}
        handleChange={(value) => {
          setFormData({ ...formData, company_name: value });
        }}
      />
      <ConstantInput
        label={localization.POCName}
        regex={Regex.text.test(formData?.poc_name)}
        errorMsg={localization.requiredPocName}
        type="text"
        required
        isStarRequired={true}
        handleChange={(value) => {
          setFormData({ ...formData, poc_name: value });
        }}
      />
      <ConstantInput
        label={localization.POCDesignation}
        regex={Regex.text.test(formData?.poc_designation)}
        errorMsg={localization.requiredPocDesig}
        type="text"
        required
        isStarRequired={true}
        handleChange={(value) => {
          setFormData({ ...formData, poc_designation: value });
        }}
      />
      <ConstantInput
        label={localization.phoneNumber}
        regex={Regex.phoneNumber.test(formData?.poc_contact_no)}
        errorMsg={localization.phoneError}
        maxLength={10}
        minLength={10}
        type="text"
        required
        isStarRequired={true}
        handleChange={(value) => {
          setFormData({ ...formData, poc_contact_no: value });
        }}
      />
      <ConstantInput
        label={localization.emailAddress}
        regex={Regex.email.test(formData?.poc_email)}
        errorMsg={localization.emailError}
        type="email"
        required
        isStarRequired={true}
        handleChange={(value) => {
          setFormData({ ...formData, poc_email: value });
        }}
      />
      <ConstantInput
        label={localization.employeeCount}
        regex={Regex.numeric.test(formData?.employee_count)}
        errorMsg={localization.emailError}
        type="numeric"
        required
        isStarRequired={true}
        handleChange={(value) => {
          setFormData({ ...formData, employee_count: value });
        }}
      />
    </FormSection>
  );
};

AddCorporateClientForm.propTypes = {};

export default AddCorporateClientForm;
